import type { LocizeNamespaces } from 'app-constants';
import type { TFunction } from 'i18next';
import type { AnyObject, Children } from 'models';
import type { ReactElement } from 'react';
import { Trans, type UseTranslationOptions } from 'react-i18next';

type AppLocalizationComponentProps = {
  locizeKey: string;
  values?: AnyObject;

  components?: Record<string, ReactElement>;

  t: TFunction<
    LocizeNamespaces,
    UseTranslationOptions<Record<string, unknown>>
  >;
  className?: string;
  children?: Children;
};

const AppLocalizationComponent = ({
  locizeKey,
  values,
  components,
  t,
  className,
  children,
}: AppLocalizationComponentProps) => {
  // Add keys to components to avoid React warning about missing keys
  const componentsWithKeys = components
    ? Object.fromEntries(
        Object.entries(components).map(([key, component]) => [
          key,
          component ? { ...component, key: key } : component,
        ]),
      )
    : undefined;

  return (
    <div className={className}>
      <Trans
        components={componentsWithKeys}
        i18nKey={locizeKey}
        t={t}
        values={values}
      >
        {children}
      </Trans>
    </div>
  );
};

export default AppLocalizationComponent;
